(function () {
  const PREFERS_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    if (root.dataset.prInitialized) return;
    root.dataset.prInitialized = 'true';

    const track = root.querySelector('[data-pr-track]');
    const slides = Array.from(root.querySelectorAll('[data-pr-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-pr-dot]'));
    if (!track || slides.length === 0) return;

    let index = 0;
    let timer = null;
    const autoplay = root.dataset.autoplay === 'true' && slides.length > 1 && !PREFERS_REDUCED_MOTION;
    const interval = Math.max(parseInt(root.dataset.interval, 10) || 6000, 2000);

    function show(i, { announce = true } = {}) {
      index = (i + slides.length) % slides.length;
      slides.forEach((slide, si) => {
        const active = si === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, di) => {
        dot.classList.toggle('is-active', di === index);
        dot.setAttribute('aria-selected', di === index ? 'true' : 'false');
      });
    }

    function next() {
      show(index + 1);
    }

    function start() {
      if (!autoplay || timer) return;
      timer = window.setInterval(next, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        stop();
        show(parseInt(dot.dataset.index, 10) || 0);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) start();
    });

    // basic swipe support for mobile
    let touchStartX = 0;
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    track.addEventListener('touchend', (e) => {
      const deltaX = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) {
        show(deltaX < 0 ? index + 1 : index - 1);
      }
      start();
    }, { passive: true });

    show(0, { announce: false });
    start();

    root._prCleanup = stop;
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-pr-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-pr-carousel]').forEach((root) => {
      if (root._prCleanup) root._prCleanup();
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-pr-slide]');
    if (!slide) return;
    const root = slide.closest('[data-pr-carousel]');
    const allSlides = Array.from(root.querySelectorAll('[data-pr-slide]'));
    const idx = allSlides.indexOf(slide);
    if (root._prCleanup) root._prCleanup();
    allSlides.forEach((s, i) => {
      s.classList.toggle('is-active', i === idx);
      s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
    });
    const dots = root.querySelectorAll('[data-pr-dot]');
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
  });
})();
